// getConfigData.js
'use strict';
import { Collection } from 'immutable';

import createCachedSelector from '../resource/createCachedSelector.js';
import { EMPTY_ARRAY } from '../resource/defaults.js';

/**
 * Select config data
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {array} selectPath - select path.
 * @param {string} dataKey - data key.
 * @return {any} The selected config data.
 */
const getConfigData = createCachedSelector(
  (state, selectPath) => state.getIn(['config', ...selectPath]),
  (state, selectPath, dataKey) => dataKey,
  (config, dataKey) => {
    let result = config;
    if (dataKey) {
      result = config?.get(dataKey);
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)(
  (state, selectPath = EMPTY_ARRAY, dataKey = '') =>
    `${selectPath.join(':')}:${dataKey}`
);

export default getConfigData;
